export default [
  {
    path: '/app/product-reynaers-cat',
    name: 'ProductReynaersCat',
    component: () => import('@/views/Admin/Product_reynaers_cat/Index.vue'),
    meta: {
      pageTitle: 'Ürün Reynaers/Rehau Ürün Özellikleri',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCTS_REYNAERS_CAT',
      action: 'read',
    },
  },
  {
    path: '/app/product-reynaers-cat/add',
    name: 'ProductReynaersCatAdd',
    component: () => import('@/views/Admin/Product_reynaers_cat/Add.vue'),
    meta: {
      pageTitle: 'Ürün Reynaers/Rehau Ürün Özellikleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/product-reynaers-cat',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCTS_REYNAERS_CAT',
      action: 'read',
    },
  },
  {
    path: '/app/product-reynaers-cat/edit/:id',
    name: 'ProductReynaersCatEdit',
    component: () => import('@/views/Admin/Product_reynaers_cat/Edit.vue'),
    meta: {
      pageTitle: 'Ürün Reynaers/Rehau Ürün Özellikleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/product-reynaers-cat',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCTS_REYNAERS_CAT',
      action: 'read',
    },
  },
]
